import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Query } from '@apollo/client/react/components';

import CurrentUserFollowingList from 'buyside/graphql/queries/CurrentUserFollowingList';

import MembersIndexCardLoading from 'buyside/components/presentation/MembersIndexPage/MembersIndexCard/membersIndexCardLoading';
import UserFollowingList from 'buyside/components/presentation/UserAccount/UsersYouFollow/userFollowingList';

import { validatePageParam } from 'buyside/util/numbers';

const UserFollowingListContaier = () => {
  const [searchParams] = useSearchParams();
  const page = validatePageParam(searchParams);

  return (
    <Query query={CurrentUserFollowingList} variables={{ page }}>
      {({ loading, data = {} }) => {
        if (loading || !data.currentUser)
          return [...Array(3)].map((_, idx) => (
            <MembersIndexCardLoading key={`following-skeleton-${idx}`} />
          ));

        return (
          <UserFollowingList
            followingList={
              data.currentUser.followingList ? data.currentUser.followingList.edges : null
            }
            activeFollowedUsersCount={data.currentUser.activeFollowedUsersCount}
            canViewUserDetails={data.currentUser.canViewUserDetails}
          />
        );
      }}
    </Query>
  );
};

export default UserFollowingListContaier;
